module.exports = __webpack_public_path__ + "static/img/erp-system-img.15f0195.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/new/erp-system-img.png
// module id = 8lno
// module chunks = 1